import { masterAPIClient } from '@/clients/MasterAPIClient';
import { IGenre } from '@/data/models/genre';
import { IOptions } from '@/data/models/option';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetGenresQuery(
  value?: string
): UseQueryResult<IOptions<IGenre>[], Error> {
  return useQuery({
    queryKey: ['genres', value],
    queryFn: () => masterAPIClient.getGenres(value),
    staleTime: Infinity,
  });
}
